/**
 * @generated SignedSource<<6addbf454704f3cd6923ddb153955a89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
import { FragmentRefs } from "relay-runtime";
export type EventDetailSignUpSection_event$data = {
  readonly attendeeListVisible: boolean;
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly supportsPublic: boolean;
      } | null | undefined;
    };
  };
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly signUps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly ownerClient: {
          readonly id?: string;
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailActions_event" | "EventDetailAttendeesList" | "EventDetailGroupDisplay_event" | "EventDetailJoinEvent_event" | "EventDetailPricingSection_event" | "EventDetailSeriesInfoBanner" | "EventDetailSignUpCard_event" | "EventDetailYourSignup_event" | "NewEventDetailAttendeesList">;
  readonly " $fragmentType": "EventDetailSignUpSection_event";
};
export type EventDetailSignUpSection_event$key = {
  readonly " $data"?: EventDetailSignUpSection_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailSignUpSection_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailSignUpSection_event",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "clientId",
          "variableName": "memberId"
        }
      ],
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpConnection",
      "kind": "LinkedField",
      "name": "signUps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "ownerClient",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "Member",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "Customer",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attendeeListVisible",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailPricingSection_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailJoinEvent_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailSignUpCard_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailGroupDisplay_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailSeriesInfoBanner"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailActions_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailYourSignup_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailAttendeesList"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewEventDetailAttendeesList"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "b5cd1f3634b6fbbd6911cdc83c8966a0";

export default node;
